// extracted by mini-css-extract-plugin
export default {"upsellContainer":"_1fHhVeER","buyerUpsellContainer":"_2xZWOram","upsellTitle":"DUF0qzfJ","buyerUpsellTitle":"_1XwqBIjb","upsellItem":"Djqq258E","buyerUpsellItem":"_2rdpEAJA"};